import React from 'react'

import Icon from '@/components/common/Icon'

const IconNewsletter: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, height, width }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 13 10"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.15714 9.25714C0.838929 9.25714 0.566518 9.14378 0.339911 8.91707C0.113304 8.69036 0 8.41778 0 8.09936V1.15264C0 0.834214 0.113304 0.5625 0.339911 0.3375C0.566518 0.1125 0.838929 0 1.15714 0H11.1857C11.5039 0 11.7763 0.113357 12.0029 0.340071C12.2296 0.566785 12.3429 0.839357 12.3429 1.15779V8.1045C12.3429 8.42293 12.2296 8.69464 12.0029 8.91964C11.7763 9.14464 11.5039 9.25714 11.1857 9.25714H1.15714ZM6.17143 5.4L1.15714 2.52321V8.1H11.1857V2.52321L6.17143 5.4ZM6.17143 4.03393L11.1857 1.15714H1.15714L6.17143 4.03393ZM1.15714 2.52321V1.15714V8.1V2.52321Z"
      fill="currentColor"
    />
  </svg>
)

export default Icon(IconNewsletter)
